export default "__VITE_ASSET__B0Fx77lQ__"